import { Component, OnDestroy, Renderer2, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-simple-page',
  templateUrl: './simple-page.component.html',
  imports: [RouterOutlet]
})
export class SimplePageComponent implements OnDestroy {
  private renderer = inject(Renderer2);

  constructor() {
    this.renderer.addClass(document.body, 'simple-page');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'simple-page');
  }
}
